const userpilot = () => (next) => (action) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  global.userpilot && global.userpilot.reload();
  return next(action);
};

export default userpilot;
